import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const create = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `modules`,
      method: "post",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Created Successfully",

        showErr: true,
        store: {
          key: args?.state,
          action: "prepend",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `modules/${args.id}`,
      method: "put",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "updated Successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "update",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "modules",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        store: {
          key: args?.state,
          action: "set",
        },
      },
    };
    const response = await request(config);

    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const remove = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `modules/${args.id}`,
      method: "delete",
      authorization: true,
      config: {
        successMsg: "Deleted Successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "remove",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export default { list, create, update, remove };
